import { useEffect, useRef, useState } from "react";
import { useRecoilValue } from "recoil";

import {
  DirectionEnum,
  IDropdownItemStations,
  StationApi,
  systemSettingsDtoAtom,
} from "@ryde/shared";

export const useHubStationsForPair = ({
  originStationId,
  destinationStationId,
  currentHubId,
  direction,
}: {
  originStationId: number | null | undefined;
  destinationStationId: number | null | undefined;
  currentHubId?: number | null;
  direction?: DirectionEnum;
}) => {
  const systemSettings = useRecoilValue(systemSettingsDtoAtom);
  const isHubLogicEnabled = Boolean(systemSettings?.metadata?.enableHubsLogic);
  const [hubStationsDropdownList, setHubStationsDropdownList] = useState<
    IDropdownItemStations[]
  >([]);
  const [isLoading, setIsLoading] = useState(false);
  const initialHubIdRef = useRef<number | undefined>(currentHubId ?? undefined);

  useEffect(() => {
    if (!isHubLogicEnabled || !originStationId || !destinationStationId) {
      setHubStationsDropdownList([]);
      setIsLoading(false);
      return;
    }

    let cancelled = false;
    setIsLoading(true);

    const fetchHubStations = async (): Promise<void> => {
      try {
        const list = await StationApi.getHubStationsForPair(
          originStationId,
          destinationStationId,
          initialHubIdRef.current,
          direction,
        );
        if (!cancelled) {
          setHubStationsDropdownList(list ?? []);
        }
      } catch {
        if (!cancelled) {
          setHubStationsDropdownList([]);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    fetchHubStations();

    return () => {
      cancelled = true;
    };
  }, [direction, destinationStationId, isHubLogicEnabled, originStationId]);

  return { hubStationsDropdownList, isHubStationsLoading: isLoading };
};
